<template>
  <ReassuranceItems>
    <BouyguesReassuranceItems
      v-if="selectedMobilePlan"
      :benefits="selectedMobilePlan.benefits"
    />
  </ReassuranceItems>
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'

import ReassuranceItems from '~/scopes/reassurance/components/ReassuranceItems/ReassuranceItems.vue'

import BouyguesReassuranceItems from './components/BouyguesReassuranceItems/BouyguesReassuranceItems.vue'

defineProps<{
  selectedMobilePlan?: MobilePlanOffer
}>()
</script>
